import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button'
import { ThemeProvider, createTheme } from '@mui/material/styles';

const ModalEntregasParcialesComponent = (props) => {

    const entregasRealizadas = props.historial

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 850,
        height: 570,
        bgcolor: '#FFFFFF',
        boxShadow: 24,
        p: 4,
        color: 'black',
        borderRadius: '8px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#7D9A47"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const [openModalEntregas, setOpenModalEntregas] = React.useState(true);

    const handleCloseModal = () => {
        setOpenModalEntregas(false)
        props.setOpenModalEntregas.setOpenModalEntregas()
    }

    const columns = [
        { field: 'numEntrega', headerName: 'No. de entrega', headerAlign: 'center', flex: 1.5 },
        { field: 'fecha', headerName: 'Fecha', headerAlign: 'center', flex: 1 },
        { field: 'hologramasEntregados', headerName: 'Hologramas entregados', headerAlign: 'center', flex: 1.5 },
        { field: 'folioInicial', headerName: 'Folio inicial', headerAlign: 'center', flex: 1 },
        { field: 'folioFinal', headerName: 'Folio final', headerAlign: 'center', flex: 1 },
    ]

    const rows = []
    let id = 0
    entregasRealizadas?.map(anexo => {
        rows.push({
            id: uuidv4(), numEntrega: Number(Number(id) + 1), fecha: anexo.fecha.substring(0, 10),
            hologramasEntregados: anexo.hologramasentregados,
            folioInicial: anexo.folioinicial, folioFinal: anexo.foliofinal
        })
        id++
    })

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModalEntregas}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" className='text-danger'>
                            <h3 style={{ color: "#072036", fontFamily: "Montserrat", fontWeight: "bold", textAlign: 'center' }}> ENTREGAS REALIZADAS </h3>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2">
                            <Box sx={{ height: 400, width: '100%', mt: 2 }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    disableColumnMenu={true}
                                    pageSize={4}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        backgroundColor: 'white',
                                        fontFamily: 'Montserrat',
                                        boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)',
                                        '& .MuiDataGrid-cell': {
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'                                        
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#0C365A',
                                            color: 'white',
                                            fontFamily: 'Montserrat',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        }
                                    }}
                                />
                            </Box>
                        </Typography>
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>
                            <ThemeProvider theme={theme}>
                                <Button variant="contained" color="primary" style={{ width: '50%' }} onClick={() => handleCloseModal()}>Aceptar</Button>
                            </ThemeProvider>
                        </Typography>
                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(ModalEntregasParcialesComponent)
